module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "interval-wrapper"
  }, [_c('h5', {
    staticClass: "interval"
  }, [_vm._v("Intervall: "), _c('v-datefield', {
    attrs: {
      "id": "start",
      "label": "Start",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _c('v-datefield', {
    attrs: {
      "id": "end",
      "label": "Slut",
      "validate": 'required|date_format:YYYY-MM-DD'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Aktiva klienter  - " + _vm._s(_vm.clients_by_status.active.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.active)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Avslutade klienter - " + _vm._s(_vm.clients_by_status.closed.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.closed)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-shadow--2dp"
  }, [_c('caption', {
    staticClass: "mdl-typography--caption"
  }, [_vm._v("Nya klienter - " + _vm._s(_vm.clients_by_status.new.length) + " st "), _c('br'), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('id'),
    on: {
      "click": function($event) {
        _vm.sort('id')
      }
    }
  }, [_vm._v("Id")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('uid'),
    on: {
      "click": function($event) {
        _vm.sort('uid')
      }
    }
  }, [_vm._v("Uid")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('gender'),
    on: {
      "click": function($event) {
        _vm.sort('gender')
      }
    }
  }, [_vm._v("Kön")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('year'),
    on: {
      "click": function($event) {
        _vm.sort('year')
      }
    }
  }, [_vm._v("Födelseår")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('start'),
    on: {
      "click": function($event) {
        _vm.sort('start')
      }
    }
  }, [_vm._v("Aktiv")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric sortheader",
    class: _vm.sortClass('end'),
    on: {
      "click": function($event) {
        _vm.sort('end')
      }
    }
  }, [_vm._v("Avslutad")])])]), _c('tbody', _vm._l((_vm.sortedTable(_vm.clients_by_status.new)), function(client) {
    return _c('tr', {
      key: client.uid,
      attrs: {
        "data-id": client.uid
      }
    }, [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.id))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.uid))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.gender))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.year))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.start))]), _c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(client.end))])])
  }))]), _vm._l((_vm.clients_by_status_and_age.by_property), function(group) {
    return _c('div', [_c('table', {
      ref: group.label,
      refInFor: true,
      staticClass: "mdl-data-table",
      attrs: {
        "id": group.label
      }
    }, [_c('caption', {
      staticClass: "tableexport-caption"
    }, [_c('b', [_vm._v(_vm._s(group.label))]), _vm._v(" fördelat på kön"), _c('br'), _c('span', {
      staticClass: "sub_caption"
    }, [_vm._v("Aktiva i perioden " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end))])]), _vm._m(0, true, false), _c('tbody', _vm._l((group.properties), function(property) {
      return _c('tr', [_c('td', {
        staticClass: "mdl-data-table__cell--non-numeric"
      }, [_vm._v(_vm._s(property.label))]), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.man, 'id'))
        }
      }), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.woman, 'id'))
        }
      }), _c('td', {
        staticClass: "mdl-data-table__cell--non-numeric",
        domProps: {
          "innerHTML": _vm._s(_vm.joinArray(property.hen, 'id'))
        }
      }), _c('td', {
        staticClass: "sum"
      }, [_vm._v(_vm._s((property.man || []).length + (property.hen || []).length + (property.woman || []).length))])])
    }))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Typ")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Män")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kvinnor")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Annat")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Totalt")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6ea6408","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administration/Table.vue
// module id = 538
// module chunks = 1